import React from 'react';
import './brand.css';

/** Single-letter gradient avatar, same look as Talk / App sidebar. */
export function userInitial(user) {
  if (!user) return 'B';
  const name = (user.full_name || user.name || user.email || 'B').trim();
  return (name[0] || 'B').toUpperCase();
}

export function userDisplayName(user) {
  if (!user) return 'Account';
  return user.full_name || user.name || user.email || 'Account';
}

export default function UserAvatar({ user, size = 'md', className = '', photoUrl, style }) {
  const src = photoUrl || user?.photo_url;
  const classes = ['byo-avatar', `byo-avatar--${size}`, className].filter(Boolean).join(' ');

  if (src) {
    return (
      <img
        src={src}
        alt=""
        className={classes}
        style={style}
        decoding="async"
      />
    );
  }

  return (
    <span className={classes} style={style} aria-hidden="true">
      {userInitial(user)}
    </span>
  );
}
